import EyeIcon from "@icons/EyeIcon"
import EyeOffIcon from "@icons/EyeOffIcon"
import React, { forwardRef, useState } from "react"
import {
    FieldWrapper,
    Label,
    OuterWrapper,
    IconWrapper,
    Helper,
    Error
} from "../styles"
import { Input } from "./styles"
import type { InputFieldProps } from "./types"

const InputField = forwardRef<HTMLInputElement, InputFieldProps>(({
    id,
    iconLeft,
    iconRight,
    label,
    helperText,
    error,
    css,
    type = "text",
    ...props
}, ref) => {
    const [isShowingPassword, setIsShowingPassword] = useState<"text" | "password">("password")

    const toggleShowingPassword = () => {
        setIsShowingPassword(((prevState) => {
            if (prevState === "password") {
                return "text"
            }
            return "password"
        }))
    }

    return <OuterWrapper css={label ? undefined : css}>
        {label && <Label css={css} htmlFor={id}>{label}</Label>}
        <FieldWrapper>
            {iconLeft && <IconWrapper position="left">{iconLeft}</IconWrapper>}
            <Input
                type={type === "password" ? isShowingPassword : type}
                ref={ref}
                hasIconLeft={!!iconLeft}
                hasIconRight={!!iconRight || type === "password"}
                hasError={!!error}
                id={id}
                {...props}
            />
            {type !== "password" && iconRight && <IconWrapper position="right">{iconRight}</IconWrapper>}
            {type === "password" && <IconWrapper
                position="right"
                isPasswordType
                onClick={toggleShowingPassword}
            >
                {isShowingPassword === "password" ? <EyeIcon /> : <EyeOffIcon />}
            </IconWrapper>}
        </FieldWrapper>
        {error && <Error>{error}</Error>}
        {helperText && <Helper>{helperText}</Helper>}
    </OuterWrapper>
})

export default InputField
